import { render, staticRenderFns } from "./BellObject.vue?vue&type=template&id=f3660736&scoped=true&"
import script from "./BellObject.vue?vue&type=script&lang=js&"
export * from "./BellObject.vue?vue&type=script&lang=js&"
import style0 from "./BellObject.vue?vue&type=style&index=0&id=f3660736&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3660736",
  null
  
)

export default component.exports